
<div :class="classes(n())">
  <div :class="classes(n('left'))">
    <div :class="classes(n('icon-wrapper'))">
      <slot name="icon">
        <StepItemIcon :activated="isIconActivated">
          {{ $props.index + 1 }}
        </StepItemIcon>
      </slot>
    </div>
    <StepItemLine
      :activated="isLineActivated"
      :horizontal="false"
      :class="classes(n('line'))"
    />
  </div>
  <div :class="classes(n('right'))">
    <slot />
  </div>
</div>
